import { render, staticRenderFns } from "./HeadersWebsite.vue?vue&type=template&id=e895ac6c&scoped=true&"
import script from "./HeadersWebsite.vue?vue&type=script&lang=js&"
export * from "./HeadersWebsite.vue?vue&type=script&lang=js&"
import style0 from "./HeadersWebsite.vue?vue&type=style&index=0&id=e895ac6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e895ac6c",
  null
  
)

export default component.exports